module.exports = fox._r("fonts/woodfordbourne-italic-webfont.woff", __webpack_public_path__ + "fonts/2OPdAho.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/woodfordbourne-italic-webfont.woff
// module id = 6
// module chunks = 5